module.exports = __webpack_public_path__ + "media/images/icons/icons_large/51_bowtie-597d3f869e8e060fd4815eadeec9a8ee.png";